// extracted by mini-css-extract-plugin
export default {"arrow_box":"SensorDetailsCard_arrow_box__inkGz"};